import InventoryViewRow from 'domains/inventory/molecules/view/inventory-view-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Badge, Spinner, Table } from 'reactstrap'


const propTypes = {
  inventory: PropTypes.object
}

/**
 * Multi-purpose Inventory view.
 * It display about the Inventory information
 * @param {object} inventory
 */
const InventoryView = ({ inventory }) => (

  <Table
    bordered
    hover
    className='mb-0'
    size='sm'
    responsive
  >
    <tbody>
      <InventoryViewRow
        label={ 'SKU Inventory' }
        value={ inventory.inventory_sku }
        tooltipId={ 'inventory_sku' }
      />
      <InventoryViewRow
        label={ 'ID' }
        value={ inventory.id }
        tooltipId={ 'id' }
      />
      <InventoryViewRow
        label={ 'Sellable Quantity' }
        value={ inventory.sellable_quantity }
        tooltipId={ 'sellable_quantity' }
      />
      <InventoryViewRow
        label={ 'Stored Quantity' }
        value={ inventory.stored_quantity }
        tooltipId={ 'stored_quantity' }
      />

      <InventoryViewRow
        label={ 'Is Preorderable' }
        value={
          inventory.is_preorderable
            ? <Badge pill color='success'>Yes</Badge>
            : <Badge pill color='warning'>No</Badge>
        }
        tooltipId={ 'is_preorderable' }
      />

      <InventoryViewRow
        label={ 'Preorder Days' }
        value={ inventory.preorder_days }
        tooltipId={ 'preorder_days' }
      />

      <InventoryViewRow
        label={ 'Preorder Date' }
        value={ inventory.preorder_date }
        tooltipId={ 'preorder_date' }
      />

      <InventoryViewRow
        label={ 'Quantity Managed' }
        value= {
          inventory.is_qty_managed
            ? <Badge pill color='success'>Yes</Badge>
            : <Badge pill color='warning'>No</Badge>
        }
        tooltipId={ 'is_qty_managed' }
      />
    </tbody>
  </Table>

)

InventoryView.propTypes = propTypes

export default withLoader(InventoryView, Spinner)
